import React, { useState, useEffect, useRef } from "react";
import clientConfig from "../../client-config";
import TCTItem from "./tctItem";
import * as styles from './threeColumnTile.module.css';
import { gsap, TweenMax, Expo } from "gsap";

function threeColumnTile(props) {

    const sectionRef = useRef();
    const titleRef = useRef();
    const subheadingRef = useRef();

    useEffect(() => {
        
        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        // TweenMax.set([titleRef.current, subheadingRef.current], {
        //     opacity: 0,
        //     y: 80
        // });

        // TweenMax.set($(sectionRef.current).find('.stagger-item'), {
        //     opacity: 0,
        //     y: 80
        // });

        if(!$(sectionRef.current).hasClass('anim-complete')){
            $(window).on('scroll', () => {
                if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){

                    // TweenMax.to(
                    //     titleRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         y: 0, 
                    //         delay : 0.25
                    //     } 
                    // );

                    // TweenMax.to(
                    //     subheadingRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         y: 0, 
                    //         delay : 0.45,
                    //         onComplete : () => {
                    //             $(sectionRef.current).addClass('anim-complete');
                    //         }
                    //     } 
                    // );

                    // TweenMax.staggerTo(
                    //     $(sectionRef.current).find('.stagger-item'),
                    //     0.45,
                    //     {
                    //         opacity: 1, 
                    //         y: 0,
                    //         delay : 0.55
                    //     },
                    //     0.25
                    // )
                    $(sectionRef.current).addClass('anim-complete');
                }
            });
        }

    });

    let bgcolor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';

    return (
        <div className={styles.sectionThreeColumnTile} style={{ backgroundColor: `${bgcolor}`}} ref={sectionRef}>
            <div className={styles.sectionContainer}>
                <h2 ref={titleRef}>{props.heading}</h2>
                <div className={styles.subHeading} ref={subheadingRef}>
                    {props.subheading}
                </div>
                <div className={styles.listWrapper}>
                    {
                        props.items.map((item, i) => {  
                            return <TCTItem item={item} key={i} />
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default threeColumnTile;